const BRAND_KITS_COLLECTION = "brand_kits";

const populateSnapshots = (snapshots) => {
  const docs = [];
  snapshots.forEach((snap) => {
    docs.push(extractSnapshotData(snap));
  });
  return docs;
};

const extractSnapshotData = (snap) => {
  if (!snap.exists) {
    return null;
  }

  return {
    id: snap.id,
    ...snap.data()
  };
};

function BrandKitsMixin() {
  return {
    async getAllBrandKits() {
      return this.collection(BRAND_KITS_COLLECTION).get().then(populateSnapshots);
    },
    async getBrandKitById(id) {
      return this.collection(BRAND_KITS_COLLECTION).doc(id).get().then(extractSnapshotData);
    },
    async getBrandKitsByOrgaId(orgaId) {
      return this.collection(BRAND_KITS_COLLECTION)
        .where("orgaId", "==", orgaId)
        .get()
        .then(populateSnapshots);
    },
    async getBrandKitByCompanyId(companyId) {
      return this.collection(BRAND_KITS_COLLECTION)
        .where("companyId", "==", companyId)
        .get()
        .then(populateSnapshots);
    },
    async createBrandKit(data) {
      const ref = await this.collection(BRAND_KITS_COLLECTION).add(data);
      const brandKit = {
        id: ref.id,
        ...data
      };
      return brandKit;
    },
    async updateBrandKit(id, data) {
      return this.collection(BRAND_KITS_COLLECTION).doc(id).set(data, { merge: true });
    },
    async deleteBrandKit(id) {
      return this.collection(BRAND_KITS_COLLECTION).doc(id).delete();
    }
  };
}

module.exports = BrandKitsMixin;
